import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { utyRoutes } from './_uty';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(utyRoutes)
  ]
})
export class UtyModule { }
